import { t } from '@lingui/core/macro';

import { WebSocketErrorCode, type WebSocketError } from '@/hooks/useAuthWebSocket';

/** Matches the MCP server progressive cooldown cap (15 minutes). */
export const MAX_RATE_LIMIT_COOLDOWN_SECONDS = 15 * 60;

export const parseRateLimitRetryAfterSeconds = (content: string): number | undefined => {
  const match = /retry after\s+(\d+)\s+seconds?/i.exec(content);
  if (match == null) {
    return undefined;
  }

  const seconds = Number(match[1]);
  if (!Number.isFinite(seconds) || seconds <= 0) {
    return undefined;
  }

  return Math.min(seconds, MAX_RATE_LIMIT_COOLDOWN_SECONDS);
};

export const getAiChatErrorMessage = (error: WebSocketError): string => {
  if (error.payload.code === WebSocketErrorCode.RATE_LIMIT_EXCEEDED) {
    const serverContent = error.payload.content.trim();
    if (serverContent) {
      return serverContent;
    }

    return t`Rate limit exceeded. Please wait before trying again.`;
  }

  return t`An error occurred while processing your request. Please contact support if the issue persists.`;
};
